namespace app.acessibilidade {
    "use strict";
    
    angular
        .module("app.acessibilidade", []);
}